import React from 'react';
import { connect } from 'react-redux';
import AdUnit from './AdUnit';
import { getAdUnitPackage } from '../../util/adUtils';

const mapStateToProps = state => ({
  country: state.country,
  breakpoint: state.events.breakpoint,
});

const InsiderAd = ({country, breakpoint}) =>
  <div className="row">
    <div className="template-item col-xs-12">
      <AdUnit country={country} value={getAdUnitPackage(country, 'Insider', breakpoint)} />
    </div>
  </div>;

export default connect(mapStateToProps)(InsiderAd);



// WEBPACK FOOTER //
// ./src/component/Ads/InsiderAd.jsx